import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';

import type { AiFeatureId, AiUsageStats } from '@mtgcraft/shared';
import { AI_USAGE_STATS_COLLECTION } from '@mtgcraft/shared';

import { firestore } from '@/services/firebase';

/** Nightly aggregate for one feature, used for pre-run estimates. Null until the first aggregation. */
export default function useAiUsageStats(feature: AiFeatureId, enabled = true) {
  return useQuery({
    queryKey: ['aiUsageStats', feature],
    queryFn: async (): Promise<AiUsageStats | null> => {
      const snapshot = await getDoc(doc(firestore, AI_USAGE_STATS_COLLECTION, feature));
      return snapshot.exists() ? (snapshot.data() as AiUsageStats) : null;
    },
    staleTime: 60 * 60 * 1000,
    enabled,
  });
}
